import { render, staticRenderFns } from "./bi-dashboard.vue?vue&type=template&id=7e47e2ba&scoped=true"
import script from "./bi-dashboard.vue?vue&type=script&lang=js"
export * from "./bi-dashboard.vue?vue&type=script&lang=js"
import style0 from "./bi-dashboard.vue?vue&type=style&index=0&id=7e47e2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e47e2ba",
  null
  
)

export default component.exports